<template>
  <a-drawer width="60%" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left"><b>{{ formTitle }}</b></a-divider>
    <a-form-model ref="form" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="气候" prop="climateId">
        <a-select v-model="form.climateId" @change="handleClimateChange">
          <a-select-option v-for="item in climateList" :value="item.id" :key="item.id">{{ item.climateName }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="种植种子" prop="seedId">
        <a-select v-model="form.seedId" allowClear>
          <a-select-option v-for="item in seedList" :value="item.id" :key="item.id">{{ item.seedName }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="面积(㎡)" prop="area">
        <a-input-number v-model="form.area" :min="1" style="width: 200px" />
      </a-form-model-item>
      <a-form-model-item label="土地位置">
        <a-input v-model="form.position" :maxLength="100" />
      </a-form-model-item>
      <a-form-model-item label="时效(月)" prop="durationMonths" v-if="form.landType === 2 && !form.isGift">
        <a-input-number v-model="form.durationMonths" :min="1" style="width: 200px" />
      </a-form-model-item>
<!--      <a-form-model-item label="是否赠送" v-if="form.landType === 2">-->
<!--        <a-switch :checked="form.isGift" @change="(checked) => form.isGift = checked" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="备注">
        <a-textarea v-model="form.remark" :rows="2" />
      </a-form-model-item>
      <a-form-model-item label="种植备注" v-if="form.status === 2">
        <a-textarea v-model="form.plantRemarkText" :rows="2" disabled />
      </a-form-model-item>
      <a-form-model-item label="种植图片" v-if="form.status === 2 && form.plantRemarkImages">
        <div>
          <img v-for="(img, idx) in form.plantRemarkImages.split(',')" :key="idx"
               :src="img" style="width: 80px; height: 80px; margin-right: 8px; object-fit: cover;" />
        </div>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">保存</a-button>
          <a-button @click="cancel">取消</a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getLand, addLand, updateLand } from '@/api/cloudplant/land'
import { listClimate } from '@/api/cloudplant/climate'
import { listSeed } from '@/api/cloudplant/seed'

export default {
  name: 'CreateForm',
  data() {
    return {
      labelCol: { span: 4 }, wrapperCol: { span: 16 }, submitLoading: false, formTitle: '', open: false, formType: 1, climateList: [], seedList: [],
      form: { id: null, climateId: undefined, seedId: undefined, landType: 1, area: 1, position: null, durationMonths: 1, isGift: false, remark: null },
      rules: {
        climateId: [{ required: true, message: '气候不能为空', trigger: 'change' }],
        seedId: [{ required: true, message: '种子不能为空', trigger: 'change' }],
        area: [{ required: true, message: '面积不能为空', trigger: 'blur' }],
        durationMonths: [{ required: true, message: '时效不能为空', trigger: 'blur' }]
      }
    }
  },
  created() { this.getClimateList() },
  methods: {
    getClimateList() { listClimate({}).then(response => { this.climateList = response.data }) },
    handleClimateChange() {
      // 当选择气候时，清空种子并加载对应气候的种子
      this.form.seedId = undefined
      this.getSeedList(this.form.climateId)
    },
    getSeedList(climateId) {
      if (!climateId) {
        this.seedList = []
        return Promise.resolve()
      }
      return listSeed({ climateId: climateId }).then(response => { 
        this.seedList = response.data
      })
    },
    onClose() { this.open = false; this.reset() },
    cancel() { this.open = false; this.reset() },
    reset() { this.formType = 1; this.form = { id: null, climateId: undefined, seedId: undefined, landType: 1, area: 1, position: null, durationMonths: 1, isGift: false, remark: null } },
    handleAdd() { this.reset(); this.formType = 1; this.open = true; this.formTitle = '添加' },
    handleUpdate(row) {
      this.reset(); this.formType = 2
      getLand({ id: row.id }).then(response => {
        // 先获取土地详情，然后加载种子列表，等种子列表加载完成后再赋值form
        const landData = response.data
        if (landData.climateId) {
          this.getSeedList(landData.climateId).then(() => {
            this.form = landData
            this.open = true
            this.formTitle = '修改'
          })
        } else {
          this.form = landData
          this.open = true
          this.formTitle = '修改'
        }
      })
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          // 如果选择了种子，则设置土地状态为已种植
          if (this.form.seedId) {
            this.form.status = 2
          }
          this.submitLoading = true
          if (this.form.id) {
            updateLand(this.form).then(() => { this.$message.success('修改成功'); this.open = false; this.$emit('ok') }).finally(() => { this.submitLoading = false })
          } else {
            addLand(this.form).then(() => { this.$message.success('新增成功'); this.open = false; this.$emit('ok') }).finally(() => { this.submitLoading = false })
          }
        }
      })
    }
  }
}
</script>
